import { FC } from 'react';
import clsx from 'clsx';
import { useRecoilValue } from 'recoil';
import { selectIsThirdFormStep } from '../../atoms';
import { useValidateStep } from '../../hooks';
import { RegistrationFormCard } from './components';
import { Root, StyledGrid, classes } from './Registration.styles';

export const Registration: FC = () => {
	const isThirdStep = useRecoilValue(selectIsThirdFormStep);

	useValidateStep();

	return (
		<div style={{ display: 'flex', justifyContent: 'center' }}>
			<StyledGrid
				container
				spacing={0}
				justifyContent='center'
				alignItems='center'
				className={clsx({
					[classes.formContainer]: !isThirdStep,
					[classes.formContainer2]: isThirdStep,
				})}
			>
				<RegistrationFormCard />
			</StyledGrid>
			<Root className={classes.root}>
				<div className={classes.image} />
			</Root>
		</div>
	);
};
